
// widgets
var my_widgets = [

  {
    type: "searchBox",
    container: "#sunlime-purecaps-search-keys",
    placeholder: "Produkte suchen..."
  },
  {
    type: "stats",
    container: "#sunlime-purecaps-search-stats",
    templates: {
    	text: `
      {{#areHitsSorted}}
        {{#hasNoSortedResults}}No relevant results{{/hasNoSortedResults}}
        {{#hasOneSortedResults}}1 relevant result{{/hasOneSortedResults}}
        {{#hasManySortedResults}}{{#helpers.formatNumber}}{{nbSortedHits}}{{/helpers.formatNumber}} relevant results{{/hasManySortedResults}}
        sorted out of {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}}
      {{/areHitsSorted}}
      {{^areHitsSorted}}
        {{#hasNoResults}}{{/hasNoResults}}
        {{#hasOneResult}}1{{/hasOneResult}}
        {{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} {{/hasManyResults}}
      {{/areHitsSorted}}
    	`,
  	},
  },
  {
    type: "hits",
    container: "#sunlime-purecaps-search-hits",
    escapeHTML: false,
    templates: {
      	 item: '<div class="c-algolia-result__entry"><a href="{{ url }}"> <img src="{{ field_product_images_uri.0 }}" alt="{{ field_product_images_alt.0 }}" width="172" height="200" loading="lazy" /></a><a href="{{ url }}" class="c-algolia-result__entry-title">{{#helpers.highlight}}{ "attribute": "title" }{{/helpers.highlight}}</a><p class="c-algolia-result__entry-subtitle">{{#helpers.highlight}}{ "attribute": "field_subtitle" }{{/helpers.highlight}}</p><form action="/cart/add" method="post" class="{{^field_product_variants}} is-hidden{{/field_product_variants}} c-algolia-result__cart-wrapper"><select name="id" class="c-algolia-result__variation-dropdown js-algolia-search-product-add-to-cart-on-change"><option value="">Größe wählen...</option>{{#field_product_variants}}{{{ . }}}{{/field_product_variants}}{{^field_product_variants.0}}{{{ field_product_variants }}}{{/field_product_variants.0}}</select><input type="hidden" name="quantity" value="1" min="1"><button class="blue-button main-button cart-button js-algolia-search-product-toggle-dropdown">In den Warenkorb</button><button type="submit" class="is-hidden js-algolia-search-product-submit"></button></form></div>',
         empty: 'Es konnten keine passenden <span class="c-algolia-result__no-result-products">Produkte</span><span class="c-algolia-result__no-result-content">Inhalte</span> zu <span class="c-algolia-result__no-result-query">{{ query }}</span> gefunden werden.',
    }
  },
  {
    'type': 'pagination',
    'container': '#sunlime-purecaps-search-pagination',
  }
]

// search types
var search_types = {
  "product": {
    "widgets": [
      {
        "type": "configure",
        "filters": "type:product AND search_api_language:\"de\"",
        "hitsPerPage": 10
      }
    ]
  },
  "content": {
    "widgets": [
      {
        "type": "configure",
        "filters": "NOT type:product AND search_api_language:\"de\"",
        "hitsPerPage": 10
      }
    ]
  }
}
    



$( document).ready( function() {

  
  // build client
  const search_client = algoliasearch(
    '9APA0EZBN4',
    '2a271a198d8e9e3d1e2351feba6bf2ad',
  );

      

   // get index data from client
  const json = {
    indexName: 'dev_purecaps_de', 
    searchClient: search_client,
  }
  


  
  let searches = {};

  // split products and content and get results for each type
  $.each(search_types, function (key,) {
    searches[key] = instantsearch( json );

    let timerId;

    // initialize widgets
    let widgets = [];
    $.each( this.widgets.concat(my_widgets), function() {
      const widget = jQuery.extend( {}, this );
      const type = widget.type;
      delete widget.type;

      // All IDs for containers are suffixed with the specific search key.
      if ('container' in widget) {
        widget.container += '-' + key;
      }

      // Debounce search for 500 milliseconds
      if( type === 'searchBox' ) {
        widget.queryHook = function( query, refine ) {
          clearTimeout( timerId );
          timerId = setTimeout( () => refine( query ), 500 );
        }
      }

      widgets.push( instantsearch.widgets[type].call( instantsearch.widgets, widget ) );
    } );
    

    searches[key].addWidgets( widgets );
    searches[key].start();

    // Replace public:// from indexed image urls with valid path to image
    searches[key].on( 'render', function() {

      let $hits_container = $('#sunlime-purecaps-search-hits-' + key);
      let $inner_container = $hits_container.closest('.c-algolia-result__inner-container');

      let $result_header = $hits_container.prev();
      let $show_all_button = $( '.js-algolia-show-all-' + key );

      let entry_images = $hits_container.find( '.c-algolia-result__entry img' );
      let available_entries = parseInt( $result_header.find( '.ais-Stats-text' ).text() );
      let is_pagination_active = $inner_container.hasClass( 'is-pagination-active' );
      
      
      let entry_links = $hits_container.find( '.c-algolia-result__entry a' );
      
      // rewrite base url to www.purecaps.net
      if (entry_links.length > 0) {
      	
        $.each( entry_links, function( idx, entry_link ) {
          let $entry_link = $( entry_link );
          
          var link = $entry_link.attr('href');
          if (!link.includes('https')) {
            var new_link = 'https://www.purecaps.net' + link;
            $entry_link.attr('href', new_link);
          }
          
        });
      
      
      }

      if( entry_images.length > 0 ) {

        // It seems like some wrappers are hidden by default without no reason
        $hits_container.find( '.c-algolia-result__entry.is-hidden' ).removeClass('is-hidden');

        $result_header.removeClass( 'is-hidden' );

        $.each( entry_images, function( idx, entry_img ) {
          let $entry_img = $( entry_img );
          
          
          // rewrite base url for urls with relative paths
          let $entry_img_src = $entry_img.attr('src');
          
          if (!$entry_img_src.includes("https")) {
            var $new_src = 'https://www.purecaps.net'+$entry_img_src;
            $entry_img.attr('src', $new_src);
          }

          // Mustache Templates can't have conditional logic, therefore we need to set the
          // 172px height for content images via JS
          if(key === "content"){
            $entry_img.attr('height', '172');
          }

          if( idx > 4 && !is_pagination_active ) {
            $entry_img.parent().parent().addClass( 'is-hidden' );
            $entry_img.parent().parent().parent().find('.c-algolia-result__cart-wrapper ').addClass('is-hidden');
          }

          if( is_pagination_active ) {
            $entry_img.parent().parent().removeClass( 'is-hidden' );
            $entry_img.parent().parent().parent().find('.c-algolia-result__cart-wrapper ').removeClass('is-hidden');
          }
          
        } );

        // Show "All Products" button if there are more than currently visible items
        if( entry_images.length < available_entries ) {
          $show_all_button.removeClass( 'is-hidden' );
        } else {
          $show_all_button.addClass( 'is-hidden' );
        }

        $('.c-algolia-result').removeClass( 'is-empty-result-' + key );
        
        $('.ais-Hits-item').addClass('l-coll l-col-12 l-col-xl-30');
        $('.ais-Hits-list').addClass('l-row');
        
        
      } else {

        // No result
        $result_header.addClass( 'is-hidden' );
        $show_all_button.addClass( 'is-hidden' );
        $('.c-algolia-result').addClass( 'is-empty-result-' + key );

      }

      checkAlgoliaEmptyResults();

    } );
    
    
  });
  


  $( document ).on( 'click', '.js-algolia-show-all-product', function( e ) {
    e.preventDefault();
    $(this).closest( '.c-algolia-result__inner-container' ).addClass( 'is-pagination-active' );
    // Re-trigger render
    searches['product'].emit( 'render' );
  } );

  $( document ).on( 'click', '.js-algolia-show-all-content', function( e ) {
    e.preventDefault();
    $(this).closest( '.c-algolia-result__inner-container' ).addClass( 'is-pagination-active' );
    // Re-trigger render
    searches['content'].emit( 'render' );
  } );

  // Connect content search with product search
  $(document).on('keydown', '#sunlime-purecaps-search-keys-content form .ais-SearchBox-input', debounce(function(){
    searches['product'].helper.setQuery($('#sunlime-purecaps-search-keys-content form .ais-SearchBox-input').val()).search();
  }, 500, {leading:false, trailing:true}));
  
  let $header_search = $( '.js-header-search' );

  if( $header_search.length > 0 ) {

    let $body = $( 'body' );
    let input_selector = '.js-header-search .ais-SearchBox-input';

    $( document ).on( 'focus', input_selector, function() {
      $body.removeClass( 'is-megamenu-open' );

      if( !$body.hasClass( 'is-active-search' ) ) {
        $body.addClass( 'is-active-search' );
        let $form = $( this ).parent();


          
          $('.site-header__icons-wrapper').css('display', 'none');
          $('.site-header__logo').css('display', 'none');
          

          let menu_width = $( '.c-menu--main' ).width();
          let current_form_width = $form.width();
          
          
          if (window.innerWidth < 600 ) {
          	$form.css( 'width', current_form_width + menu_width-60 + 'px' );
          } else if (window.innerWidth < 1130 ) {
          	$form.css('width', '95vw');
          } else {
          	$form.css( 'width', current_form_width + menu_width-20 + 'px' );
          }
        
        	

      }
    } )


    $( document ).on( 'click', '.js-close-algolia-search', function() {

      let $input = $(input_selector);
      $input.val('');
      $body.removeClass( 'is-active-search' );
      $input.parent().css( 'width', '100%' );
      $('.site-header__icons-wrapper').css('display', 'flex');
      setTimeout(function() {
      	$('.site-header__logo').css('display', 'block');
      }, 200);
      

    });

  }
  
  
  
  

} );



function checkAlgoliaEmptyResults() {
  let $product_results = $('.c-algolia-result__inner-container--products .c-algolia-result__entry img');
  let $content_results = $('.c-algolia-result__inner-container--content .c-algolia-result__entry img');
  let $recommended_posts = $( '.c-algolia-result__recommended-posts' );
  let $recommended_products = $( '.c-algolia-result__recommended-products' );
  let $empty_result = $('.c-algolia-result__results .ais-Hits--empty');

  if ($product_results.length === 0 && $content_results.length === 0) {
    $recommended_products.removeClass('is-hidden');
    $recommended_posts.addClass( 'is-hidden' );
    $empty_result.css('display', 'block');
  } else if ($content_results.length === 0){
    $recommended_posts.removeClass( 'is-hidden' );
    $recommended_products.addClass('is-hidden');
    $empty_result.removeAttr('style');
  } else if($product_results.length === 0) {
    $recommended_products.removeClass('is-hidden');
    $recommended_posts.addClass( 'is-hidden' );
    $empty_result.removeAttr('style');
  } else {
    $recommended_products.addClass('is-hidden');
    $recommended_posts.addClass( 'is-hidden' );
    $empty_result.removeAttr('style');
  }
}

function debounce(func, timeout = 300){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

$(document).on('change', '.js-algolia-search-product-add-to-cart-on-change', function(e){;
  $(this).siblings('.js-algolia-search-product-submit').trigger('click');
});


$(document).on('click', '.js-algolia-search-product-toggle-dropdown', function(e){
  e.preventDefault();
  let $select = $(this).siblings('.c-algolia-result__variation-dropdown');

  if ($select.find('option').length < 3) {
    $select.val($select.find('option:nth-of-type(2)').attr('value'));
    $(this).siblings('.js-algolia-search-product-submit').trigger('click');
  } else {
    $select.parent().addClass('is-active');
  }
});




    


